import script from "./OrderCellLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCellLabel.vue?vue&type=script&setup=true&lang=js"

import "./OrderCellLabel.vue?vue&type=style&index=0&id=7c9b1509&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c9b1509"]])

export default __exports__